// assets/whatsapp-fab.js
// Constrói URL do wa.me com mensagem contextual no clique.

(function() {
  function buildMessage(el) {
    const pageType = el.dataset.pageType;
    const sku = el.dataset.productSku;
    const title = el.dataset.productTitle;
    const url = window.location.href;

    if (pageType === 'product' && sku) {
      return `Olá! Tenho interesse em:%0A%0A*${title}*%0ASKU: ${sku}%0A${url}%0A%0APreciso de cotação.`;
    }
    if (pageType === 'collection') {
      return `Olá! Estou navegando ${url} e preciso de ajuda com cotação.`;
    }
    return `Olá! Tudo bem? Vim do site expansiv.com.br e preciso de ajuda.`;
  }

  function init() {
    const fabs = document.querySelectorAll('[data-wa-fab]');
    fabs.forEach(fab => {
      fab.addEventListener('click', function(e) {
        e.preventDefault();
        const number = fab.dataset.waNumber;
        const message = buildMessage(fab);
        const url = `https://wa.me/${number}?text=${message}`;
        window.open(url, '_blank', 'noopener');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
